import { isDef } from "@redotech/util/checks";
import { epochSecondsToInstant } from "@redotech/util/temporal";
import jwtDecode from "jwt-decode";
import { getLocalStorageJson } from "./local-storage-wrapper";
import { CUSTOMER_WIDGET_TOKEN_KEY } from "./shared-conf";

export function parseAuth(token: string) {
  const decoded = jwtDecode<any>(token);
  return {
    expiration: epochSecondsToInstant(decoded.exp),
    teamId: decoded.teamId ?? decoded.aud.split("/")[1],
    customerEmail: decoded.customerEmail ?? decoded.sub,
    token,
  };
}

export function getCustomerWidgetAuthToken(): string | undefined {
  const token = getLocalStorageJson(CUSTOMER_WIDGET_TOKEN_KEY);
  if (token === null) {
    return undefined;
  }

  const parsedAuth = parseAuth(token);
  if (parsedAuth.expiration.since(Temporal.Now.instant()).sign < 0) {
    return undefined;
  }

  return token;
}

export function isLoggedInToStorefront(): boolean {
  const token = getCustomerWidgetAuthToken();
  return isDef(token);
}
